const BackofficeBff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const FastDeliveryCargoManagementQuery = {
    GetShippingCompanyForFastCargo: BackofficeBff + '/v1/cargo/get-shipping-company-for-fast-cargo',
    GetFastDeliveryCargo: BackofficeBff + '/v1/cargo/get-fast-cargo-management',
};
